import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { removeNullFields } from "../../../common/mapper";
import { tableColumns } from "../config";
import PengajuanSSUFilter from "./pengajuanSSUFilter";
import M from "moment";
import { SSUStatus } from "../../../common/Constants";
import * as R from "ramda";

class PengajuanSSUTable extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        setCellProps: () => ({
          style: {
            width: "5%",
          },
        }),
      },
    },
    ...tableColumns,
    {
      name: "ssuStatus",
      label: "Aksi",
      options: {
        customBodyRender: (val, { rowIndex }) => (
          <>
            {val === "DRAFT" && this.props.state.activeIndex === 0 ? (
              <SimpleButton
                className="margin-left-none"
                secondary
                onClick={() => this.handleShowAlert(rowIndex)}
              >
                SUBMIT
              </SimpleButton>
            ) : (
              <></>
            )}
          </>
        ),
      },
    },
  ];

  constructor(props) {
    super(props);
    this.pagination = this.props.state.pagination;
    this.fakturInitialData = {
      fromTime: null,
      toTime: null,
    };
    this.state = {
      loading: false,
      filterVisible: false,
      filterData: {
        ...this.fakturInitialData,
        // variant: [{label: "ALL", value: "ALL"}],
        // warna: [{label: "ALL", value: "ALL"}],
        variant: [],
        warna: [],
      },
      showAlert: false,
      selectedIndex: null,
    };
  }

  handleShowAlert = (index) => {
    this.setState((prevState) => ({
      ...prevState,
      showAlert: !prevState.showAlert,
      selectedIndex: index,
      selectedData: R.isNil(index) ? null : this.props.state.dataTable[index],
    }));
  };

  handleOnSubmitSSU = () => {
    const { page, limit } = this.props.state.pagination;
    let data = this.state.selectedData;
    data = {
      ...data,
      kodeVariant: data.variant.kodeVariant,
      kodeWarna: data.warna?.id,
      ssuStatus: SSUStatus.DIPROSES,
      ssuDate: M(new Date()).format("DD-MM-yyyy"),
      kodeCabang: this.props.state.search.kodeCabang.value,
      submitterName: this.props.user.name,
    };
    const { variant, warna, stnkName, customerName, ...request } = data;
    this.setState((prevState) => ({
      ...prevState,
      showAlert: false,
      selectedIndex: null,
      selectedData: null,
      filterData: {
        ...this.fakturInitialData,
        variant: [{ label: "ALL", value: "ALL" }],
        warna: [{ label: "ALL", value: "ALL" }],
      },
    }));
    this.props.onSubmitSSU({
      ...request,
      __pagination: { page, limit }, 
    });
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleSubmitFilter = (e) => {
    let { warnaRaw, variantOptions } = this.props.state;
    e.preventDefault();
    
    let filterData = { ...this.state.filterData };

    if (Array.isArray(filterData.variant) && filterData.variant.length === 0) {
      filterData.variant = [{ label: "ALL", value: "ALL" }];
    }
    if (Array.isArray(filterData.warna) && filterData.warna.length === 0) {
      filterData.warna = [{ label: "ALL", value: "ALL" }];
    }
   
    let request = removeNullFields({ ...filterData });
    let variant = request.variant
      ? request.variant.some((v) => v.value === "ALL")
        ? variantOptions.map((v) => v.value).filter((v) => v !== "ALL")
        : request.variant.map((v) => v.value)
      : null;
   
    let warna =
      R.isNil(variant) || R.isEmpty(variant)
        ? null
        : request.warna
        ? request.warna.some((w) => w.value === "ALL")
          ? warnaRaw
              .filter((w) => variant.includes(w.kodeVariant))
              .map((w) => w.id)
          : request.warna.map((w) => w.value)
        : null;

    request = {
      ...request,
      warna,
      variant,
      fromTime: request.fromTime
        ? M(request.fromTime).format("DD-MM-yyyy")
        : null,
      toTime: request.toTime ? M(request.toTime).format("DD-MM-yyyy") : null,
    };

    request = removeNullFields({ ...request });

    this.handleFilterVisibility();
    this.props.onSubmitFilter(request);
  };

  handleResetFilter = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...this.fakturInitialData,
      },
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  render() {
    return (
      <>
        <FlexView hAlignContent="right">
          <SimpleButton
            className="btn background-red margin-bottom-15px"
            category="action_button"
            icon={<i className="fa fa-qrcode"></i>}
            onClick={this.handleFilterVisibility}
          />
        </FlexView>
        <SimpleDataTable
          data={this.props.state.dataTable}
          columns={this.tableColumns}
          toCount={this.props.state.pagination.totalData}
          rowsPerPage={this.props.state.pagination.limit}
          page={this.props.state.pagination.page - 1}
          options={defaultTableChange(
            this.props.onChangePage,
            this.props.onChangeRowsPerPage
          )}
        />
        {this.state.filterVisible && (
          <PengajuanSSUFilter
            state={this.state}
            options={{
              warnaOptions: this.props.state.warnaOptions,
              variantOptions: this.props.state.variantOptions,
              warnaRaw: this.props.state.warnaRaw,
            }}
            onClickClose={this.handleFilterVisibility}
            onReset={this.handleResetFilter}
            onChange={this.handleValueChange}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {this.state.showAlert && (
          <SimpleAlert
            title="Information"
            visible={this.state.showAlert}
            onClickClose={() => this.handleShowAlert(null)}
            content={
              <div style={{ textAlign: "left" }}>
                <p>Data</p>
                <br />
                <p>
                  Nomor Faktur Jual: {this.state.selectedData.salesFakturNo}
                </p>
                <p>Nomor Rangka: {this.state.selectedData.frameNumber}</p>
                <p>Nomor Mesin: {this.state.selectedData.engineNumber}</p>
                <br />
                <p>DISUBMIT untuk PENGAJUAN SSU, apakah anda yakin ?</p>
                <FlexView hAlignContent="right" className="margin-top-15px">
                  <SimpleButton
                    secondary
                    onClick={() => this.handleShowAlert(null)}
                  >
                    Batal
                  </SimpleButton>
                  <SimpleButton onClick={this.handleOnSubmitSSU}>
                    Iya
                  </SimpleButton>
                </FlexView>
              </div>
            }
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

export default PengajuanSSUTable;
